import { createBrowserRouter } from "react-router-dom";
import AppLayout from "./components/layout/AppLayout";
import BuilderLayout from "./components/layout/BuilderLayout";
import ProtectedRoute from "./auth/ProtectedRoute";
import RequireRole from "./auth/RequireRole";
import StatusPage from "./pages/StatusPage";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import ProfilePage from "./pages/ProfilePage";
import ProjectsPage from "./pages/ProjectsPage";
import NewProjectPage from "./pages/NewProjectPage";
import WizardPage from "./pages/WizardPage";
import ProjectDetailPage from "./pages/ProjectDetailPage";
import BuilderPage from "./pages/BuilderPage";
import EditorPage from "./pages/EditorPage";
import DatabasePage from "./pages/DatabasePage";
import VersionsPage from "./pages/VersionsPage";
import TemplatesPage from "./pages/TemplatesPage";
import UsagePage from "./pages/UsagePage";
import BillingPage from "./pages/BillingPage";
import SettingsPage from "./pages/SettingsPage";
import OrganizationsPage from "./pages/admin/OrganizationsPage";
import UsersPage from "./pages/admin/UsersPage";
import PlansPage from "./pages/admin/PlansPage";
import AiProvidersPage from "./pages/admin/AiProvidersPage";
import AdministrationPage from "./pages/admin/AdministrationPage";
import ObservabilityPage from "./pages/admin/ObservabilityPage";
import SystemHealthPage from "./pages/admin/SystemHealthPage";
import NotFoundPage from "./pages/NotFoundPage";

/**
 * Fonte única de verdade das rotas do frontend.
 * Públicas usam AppLayout; autenticadas usam BuilderLayout (sidebar).
 */
export const router = createBrowserRouter([
  {
    element: <AppLayout />,
    children: [
      { path: "/", element: <StatusPage /> },
      { path: "/login", element: <LoginPage /> },
    ],
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <BuilderLayout />,
        children: [
          { path: "/dashboard", element: <DashboardPage /> },
          { path: "/projects", element: <ProjectsPage /> },
          { path: "/projects/new", element: <NewProjectPage /> },
          { path: "/projects/new/wizard", element: <WizardPage /> },
          { path: "/projects/:id", element: <ProjectDetailPage /> },
          { path: "/projects/:id/builder", element: <BuilderPage /> },
          { path: "/projects/:id/editor", element: <EditorPage /> },
          { path: "/projects/:id/database", element: <DatabasePage /> },
          { path: "/projects/:id/versions", element: <VersionsPage /> },
          { path: "/templates", element: <TemplatesPage /> },
          { path: "/usage", element: <UsagePage /> },
          { path: "/billing", element: <BillingPage /> },
          { path: "/settings", element: <SettingsPage /> },
          { path: "/profile", element: <ProfilePage /> },
          {
            // Guarda apenas visual: a autorização real é do backend.
            element: <RequireRole roles={["superadmin", "master", "franqueado"]} />,
            children: [
              { path: "/admin", element: <AdministrationPage /> },
              { path: "/admin/organizations", element: <OrganizationsPage /> },
              { path: "/admin/users", element: <UsersPage /> },
            ],
          },
          {
            element: <RequireRole roles={["superadmin", "master"]} />,
            children: [
              { path: "/admin/plans", element: <PlansPage /> },
              { path: "/admin/ai-providers", element: <AiProvidersPage /> },
            ],
          },
          {
            // Operação e saúde: exclusivo do superadmin (validado no backend).
            element: <RequireRole roles={["superadmin"]} />,
            children: [
              { path: "/admin/observability", element: <ObservabilityPage /> },
              { path: "/admin/system", element: <SystemHealthPage /> },
            ],
          },
        ],
      },
    ],
  },
  {
    element: <AppLayout />,
    children: [{ path: "*", element: <NotFoundPage /> }],
  },
]);
